import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {
  selectIsFeatureEnabled,
  selectHasLoadedFeatures,
} from 'state/feature/featureSelectors';
import {loadFeatures} from 'state/feature/featureActions';
import {FEATURE_SWITCHES} from 'app/FeatureSwitches';
export {FEATURE_SWITCHES} from 'app/FeatureSwitches';

class _Feature extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    const {children, hasLoadedFeatures, isEnabled} = this.props;
    return children({
      hasLoadedFeatures,
      isEnabled,
    });
  }
}

const Feature = connect(
  (state, {feature}) => ({
    isEnabled: selectIsFeatureEnabled(state, feature),
    hasLoadedFeatures: selectHasLoadedFeatures(state),
  }),
  {
    load: loadFeatures,
  }
)(_Feature);

Feature.propTypes = {
  feature: PropTypes.oneOf(Object.values(FEATURE_SWITCHES)).isRequired,
};

export const FeatureEnabled = ({feature, children, disabledContent}) => (
  <Feature feature={feature}>
    {({isEnabled, hasLoadedFeatures}) => {
      if (!hasLoadedFeatures) return null;
      const content = isEnabled ? children : disabledContent;

      return content ? React.Children.only(content) : null;
    }}
  </Feature>
);

FeatureEnabled.propTypes = {
  disabledContent: PropTypes.node,
};

export const FeatureDisabled = ({feature, children, enabledContent}) => (
  <Feature feature={feature}>
    {({isEnabled, hasLoadedFeatures}) => {
      if (!hasLoadedFeatures) return null;
      const content = isEnabled ? enabledContent : children;

      return content ? React.Children.only(content) : null;
    }}
  </Feature>
);

FeatureDisabled.propTypes = {
  enabledContent: PropTypes.node,
};
